import Reveal from "./Reveal";
import pdfCevre from "../assets/policies/ÇEVRE KORUMA VE ATIK POLİTİKASI.pdf";
import pdfCocuk from "../assets/policies/ÇOCUK HAKLARI POLİTİKASI.pdf";
import pdfEnerji from "../assets/policies/ENERJİ VERİMLİLİĞİ POLİTİKASI.pdf";
import pdfKadin from "../assets/policies/KADIN HAKLARI VE CİNSİYET EŞİTLİĞİ POLİTİKASI.pdf";
import pdfKulturel from "../assets/policies/KÜLTÜREL MİRAS SUNULMASI VE KORUNMASI VE KÜLTÜREL ETKİLEŞİM POLİTİKASI.pdf";
import pdfSatinAlma from "../assets/policies/SÜRDÜRÜLEBİLİR SATIN ALMA POLİTİKASI.pdf";
import pdfSurdurulebilirlik from "../assets/policies/SÜRDÜRÜLEBİLİRLİK POLİTİKASI.pdf";
import pdfYaban from "../assets/policies/YABAN HAYATIN KORUNMASI VE HAYVAN SAĞLIĞI POLİTİKASI.pdf";
import pdfYerel from "../assets/policies/YEREL TOPLUM İLİŞKİLERİ VE SOSYAL SORUMLULUK POLİTİKASI.pdf";

const policies = [
  {
    title: "Sürdürülebilirlik Politikası",
    text: "Misafir memnuniyetini her zaman önceliğimiz olarak kabul ediyor, bu anlayışı çevreye ve topluma karşı olan sorumluluklarımızla birleştiriyoruz. Tüm faaliyetlerimizi yürütürken yasal gerekliliklere eksiksiz uymayı, çalışanlarımızın sağlık ve güvenliğini korumayı, insan haklarına saygılı ve kapsayıcı bir çalışma ortamı oluşturmayı temel ilke ediniriz. Doğal kaynakların korunması, enerji ve su tüketiminin azaltılması, atıkların doğru yönetilmesi ve yerel ekonomiye katkı sağlanması yoluyla sürdürülebilir turizm anlayışını yaşatmayı hedefliyoruz. Tesisimizde, sürekli iyileşme yaklaşımı ile süreçlerimizi gözden geçirir, daha iyiye ulaşmak için çalışanlarımız, misafirlerimiz ve iş ortaklarımızla birlikte hareket ederiz.",
    pdf: pdfSurdurulebilirlik,
  },
  {
    title: "Çevre Koruma ve Atık Yönetimi Politikası",
    text: "Çevrenin korunmasını, işletmemizin vazgeçilmez sorumluluklarından biri olarak görüyoruz. Atıklarımızı kaynağında doğru şekilde ayırarak, geri dönüşüm ve yeniden kullanım imkânlarını en üst düzeye çıkarmaya özen gösteriyoruz. Tehlikeli atıkların ve kimyasalların sadece ihtiyaç halinde ve kontrollü bir şekilde kullanılmasını sağlayarak, çevresel etkileri azaltmayı amaçlıyoruz. Tek kullanımlık malzemelerin tüketimini azaltmak, kâğıt ve ambalaj kullanımını minimumda tutmak ve çevre dostu ürünleri tercih etmek için sürekli çaba gösteriyoruz. Su, enerji ve diğer doğal kaynakların tasarruflu kullanımı konusunda hem çalışanlarımızı hem misafirlerimizi bilinçlendiriyor; performansımızı düzenli olarak ölçerek, daha iyi bir çevre yönetimi için hedefler belirliyoruz.",
    pdf: pdfCevre,
  },
  {
    title: "Enerji Verimliliği Politikası",
    text: "İklim krizi ve doğal kaynakların tükenme riskine karşı enerjiyi verimli kullanmanın öneminin farkındayız. Bu nedenle, tesisimizdeki enerji tüketimini azaltmak için enerji verimliliği yüksek ekipmanlar ve teknolojiler kullanmaya özen gösteriyoruz. Enerji performansımızı düzenli olarak izliyor, elde ettiğimiz veriler doğrultusunda yeni hedefler koyarak iyileştirme çalışmaları yürütüyoruz. Çalışanlarımızı enerji tasarrufu konusunda bilinçlendirmek için eğitimler düzenliyor, misafirlerimizi de bu sürece dahil ederek ortak bir farkındalık yaratmayı amaçlıyoruz. Olası enerji kısıtları ve acil durumlara karşı önlemlerimizi planlayarak, hizmet kalitemizden ödün vermeden sorumlu bir enerji yönetimi yürütüyoruz.",
    pdf: pdfEnerji,
  },
  {
    title: "Sürdürülebilir Satın Alma Politikası",
    text: "Satın alma süreçlerimizi planlarken yalnızca maliyet ve kaliteyi değil, çevresel ve sosyal etkileri de gözetiyoruz. Tercihlerimizi, çevreye duyarlı, sürdürülebilir üretim yapan, etik değerlere önem veren ve ilgili standartlara sahip tedarikçilerden yana kullanıyoruz. Mümkün olduğunca yerel ve bölgesel üreticilerle çalışarak hem bölge ekonomisine katkı sağlıyor hem de nakliyeden kaynaklanan karbon salımını azaltmayı hedefliyoruz. Geri dönüştürülebilir veya geri dönüştürülmüş malzemelerden üretilen ürünleri, daha az ambalaj kullanan çözümleri ve çevre dostu temizlik, gıda ve kozmetik ürünlerini tercih ediyoruz. Tedarikçilerimizle kurduğumuz iş birliğini, sürdürülebilirlik bilincini yaygınlaştırmak ve uzun vadeli, karşılıklı faydaya dayalı ilişkiler geliştirmek için bir fırsat olarak görüyoruz.",
    pdf: pdfSatinAlma,
  },
  {
    title: "Çocuk Hakları Politikası",
    text: "Çocukları geleceğin emaneti olarak görüyor, tesisimizde ve iş ilişkilerimizde tüm çocukların güvenliğini ve refahını şart kabul ediyoruz. İşletmemizde hiçbir şekilde çocuk işçi çalıştırmıyor, iş ortaklarımızdan da aynı hassasiyeti göstermelerini bekliyoruz. Çocukların kendilerini güvende hissedecekleri, özgürce ifade edebilecekleri ortamlar oluşturmaya özen gösteriyor; çocuk istismarının her türüne karşı sıfır tolerans politikası benimsiyoruz. Çalışanlarımızı çocuk istismarının fark edilmesi ve önlenmesi konusunda eğitiyor, şüpheli bir durumla karşılaşıldığında gerekli kurumlara bildirim yapılmasını destekliyoruz. Çocuk hakları konusunda farkındalık oluşturacak çalışmalara ve sosyal sorumluluk projelerine katılarak, çocukların korunmasına yönelik toplumsal bilincin artmasına katkıda bulunuyoruz.",
    pdf: pdfCocuk,
  },
  {
    title: "Kadın Hakları ve Cinsiyet Eşitliği Politikası",
    text: "İşletmemizde cinsiyet eşitliğini temel bir ilke olarak kabul ediyor, tüm çalışanlarımıza eşit fırsatlar sunmaya özen gösteriyoruz. Kadınların iş gücüne katılımını destekliyor, işe alım, terfi, ücretlendirme ve görev dağılımı süreçlerinde cinsiyete dayalı hiçbir ayrımcılığa izin vermiyoruz. “Eşit işe eşit ücret” anlayışıyla hareket ederek, kadın ve erkek çalışanlarımızın kariyer olanaklarından eşit ölçüde faydalanmasını sağlamak için gerekli koşulları oluşturuyoruz. Çalışanlarımızın iş-aile yaşam dengelerini gözeten uygulamalar geliştiriyor, kadınların yönetim kademelerinde daha fazla yer almasını teşvik ediyoruz. İstismar, taciz, mobbing veya ayrımcılık içeren hiçbir davranışı tolere etmiyor, kadınların güvenli, saygılı ve destekleyici bir çalışma ortamında yer alması için kararlılıkla hareket ediyoruz.",
    pdf: pdfKadin,
  },
  {
    title: "Kültürel Mirasın Korunması ve Sunulması Politikası",
    text: "Bulunduğumuz bölgenin tarihi, kültürel ve doğal mirasının önemli bir parçası olduğumuzun bilinciyle hareket ediyoruz. Yerel kültürü, gelenekleri, değerleri ve tarihi dokuyu misafirlerimize tanıtmayı, bunu yaparken de kültürel mirasa zarar verebilecek her türlü faaliyetten kaçınmayı taahhüt ediyoruz. Kültürel mirasın korunmasına yönelik çalışmalarda sivil toplum kuruluşları, yerel yönetimler ve ilgili kurumlarla iş birliği yapıyor; bilgilendirici materyaller, etkinlikler ve içerikler aracılığıyla misafirlerimizin farkındalığını artırmayı amaçlıyoruz. Bölgenin kültürel zenginliğini yaşatmak için yerel sanat, müzik, gastronomi ve el sanatlarını destekliyor ve bu alanlarda düzenlenen etkinliklere katkı sunuyoruz.",
    pdf: pdfKulturel,
  },
  {
    title: "Yaban Hayatı ve Hayvan Sağlığının Korunması Politikası",
    text: "Doğal yaşamın, bölgenin en değerli hazinelerinden biri olduğuna inanıyor ve yaban hayatını korumayı temel sorumluluklarımız arasında görüyoruz. Yaban hayvanlarıyla kurulacak her türlü etkileşimde yerel, ulusal ve uluslararası mevzuata uygun hareket ediyor; bu konuda uzman görüşlerini dikkate alıyoruz. Hayvanların doğal davranışlarını bozabilecek, onları bağımlı hale getirebilecek besleme gibi müdahalelerden kaçınıyor, yaban hayatını rahatsız etmeyecek uygulamalar benimsiyoruz. Hayvan refahını gözeten, sağlık durumlarını ve yaşam koşullarını etkileyebilecek olumsuzlukları en aza indirmeyi hedefleyen bir yaklaşım ile hareket ediyoruz. Evcil hayvanlar söz konusu olduğunda da bakım, barınma ve muamele süreçlerinde hayvan haklarına saygılı, yasal düzenlemelerle uyumlu ve şefkatli bir anlayış sergiliyoruz.",
    pdf: pdfYaban,
  },
  {
    title: "Yerel Toplum İlişkileri ve Sosyal Sorumluluk Politikası",
    text: "Tesisimizin, içinde bulunduğu bölgenin sosyal ve ekonomik yaşamının bir parçası olduğunun bilinciyle hareket ediyoruz. Yerel halkla güçlü ve saygılı ilişkiler kurmayı, karar süreçlerimizde bölgenin ihtiyaçlarını ve hassasiyetlerini dikkate almayı önemsiyoruz. Mümkün olduğunca ürün ve hizmet tedarikini yerel işletmelerden sağlayarak hem bölge ekonomisine destek oluyor hem de çevresel etkileri azaltıyoruz. İşe alım süreçlerinde yerel istihdama öncelik veriyor; eğitim, çevre, çocuklar, engelli bireyler ve toplumsal dayanışma gibi alanlarda yürütülen sosyal sorumluluk projelerine gönüllü olarak katkıda bulunuyoruz. Gelecek nesillere daha yaşanabilir bir çevre bırakmak için ağaç dikimi, geri dönüşüm ve toplumsal farkındalık çalışmalarına aktif katılım sağlıyoruz.",
    pdf: pdfYerel,
  },
];

const PolicyCard = ({ title, text, pdf }) => {
  return (
    <div
      style={{
        background: "white",
        padding: "1.75rem",
        borderRadius: "12px",
        marginBottom: "1.5rem",
        boxShadow: "0 6px 20px rgba(20,20,40,0.06)",
        border: "1px solid rgba(14,27,77,0.06)",
      }}
    >
      <h3
        style={{ marginBottom: "0.75rem", color: "#0e1b4d", fontSize: "1.2rem" }}
      >
        {title}
      </h3>
      <p style={{ marginBottom: "1.1rem", lineHeight: 1.7, color: "#333" }}>
        {text}
      </p>

      <a
        href={pdf}
        download
        style={{
          display: "inline-block",
          background: "#0e1b4d",
          color: "white",
          padding: "0.65rem 1.4rem",
          borderRadius: "8px",
          textDecoration: "none",
          fontSize: "0.9rem",
          fontWeight: 600,
        }}
      >
        PDF İndir
      </a>
    </div>
  );
};

const Surdurulebilirlik = () => {
  return (
    <section
      id="surdurulebilirlik"
      style={{
        padding: "clamp(3.5rem, 8vw, 5rem) 1.5rem",
        background: "#f7f7f7",
      }}
    >
      <Reveal>
        <h2
          style={{
            textAlign: "center",
            marginBottom: "2.5rem",
            color: "#0e1b4d",
            fontSize: "clamp(1.6rem, 3vw, 2.2rem)",
          }}
        >
          Sürdürülebilirlik Politikalarımız
        </h2>
      </Reveal>

      <div style={{ maxWidth: "820px", margin: "0 auto" }}>
        {policies.map((policy, i) => (
          <Reveal key={policy.title} delay={(i % 3) * 80}>
            <PolicyCard {...policy} />
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Surdurulebilirlik;
